import React from 'react';

const GalleryGrid = ({ images, onImageClick }) => {
  if (images.length === 0) return null;

  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '16px',
        justifyContent: 'center',
      }}
    >
      {images.map((image, index) => {
        const position = image.imagePosition || { x: 0, y: 0 };
        const objectPosition = `50% ${50 + position.y}%`;

        // Calculate item width based on image count
        // 1 image: single centered image
        // 2 images: two side by side
        // 3+: three per row on large, two on medium
        let itemStyle = {};
        if (images.length === 1) {
          itemStyle = { width: '300px', maxWidth: '100%' };
        } else if (images.length === 2) {
          itemStyle = { width: 'calc(50% - 8px)', maxWidth: '400px' };
        } else {
          // 3+ images: responsive sizing
          // ~31% allows 3 per row with gaps, falls to 2 per row on smaller widths
          itemStyle = { width: 'calc(33.333% - 11px)', minWidth: '200px', maxWidth: '400px' };
        }

        return (
          <div
            key={image.id}
            className="relative group overflow-hidden rounded-lg bg-gray-100 cursor-pointer"
            onClick={() => onImageClick(index)}
            onMouseEnter={(e) => e.stopPropagation()}
            onMouseLeave={(e) => e.stopPropagation()}
            style={itemStyle}
          >
            <div style={{ paddingBottom: '100%', position: 'relative' }}>
              <img
                src={image.imageUrl}
                alt={image.altText}
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  objectPosition,
                  transition: 'transform 0.3s ease',
                }}
                className="group-hover:scale-105"
              />
            </div>
            {image.caption && (
              <div
                className="opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  background: 'linear-gradient(to top, rgba(0,0,0,0.7), transparent)',
                  padding: '16px',
                }}
              >
                <p style={{ color: '#FFFFFF', fontSize: '14px' }}>{image.caption}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default GalleryGrid;
